/**
 * Service pour les opérations sur le catalogue de formations
 * Aucune logique métier, uniquement des appels API
 */

import { api } from './api.js'

export const formationsCatalogueService = {
  list: (params = {}) => {
    const queryString = new URLSearchParams(params).toString()
    const url = queryString ? `/api/formation-catalogue?${queryString}` : '/api/formation-catalogue'
    return api.get(url)
  },

  create: (data) => api.post('/api/formation-catalogue', data),

  update: (id, data) => api.patch(`/api/formation-catalogue/${id}`, data),

  delete: (id) => api.delete(`/api/formation-catalogue/${id}`),

  // entreprise: 1 (Alertis 1, défaut) ou 2 (Alertis 2)
  uploadProgrammePdf: (id, formData) => api.post(`/api/formation-catalogue/${id}/programme-pdf`, formData),

  downloadProgrammePdf: (id, entreprise = 1) => api.get(`/api/formation-catalogue/${id}/programme-pdf?entreprise=${entreprise}`),

  deleteProgrammePdf: (id, entreprise = 1) => api.delete(`/api/formation-catalogue/${id}/programme-pdf?entreprise=${entreprise}`),

  renameProgrammePdf: (id, newName, entreprise = 1) => api.patch(`/api/formation-catalogue/${id}/programme-pdf`, { newName, entreprise }),

  getFormules: (id) => api.get(`/api/formation-catalogue/${id}/formules`),
  getUsages: (id) => api.get(`/api/formation-catalogue/${id}/usages`),
  setFormules: (id, formules) => api.put(`/api/formation-catalogue/${id}/formules`, { formules }),

  getCompetences: (id) => api.get(`/api/formation-catalogue/${id}/competences`),
  setCompetences: (id, competences) => api.put(`/api/formation-catalogue/${id}/competences`, { competences }),
}
